module.exports = __webpack_public_path__ + "static/fonts/SCDream1.47fb61a.otf";